import React, { FC } from 'react';
import _ from 'lodash';
import { Svg, GetTradingBlockSiteName } from '@tradingblock/components';
import { useStateSelector } from '../../data/global/dataSelectors';

const NewsStatusIconButton: React.FC<{ cssClasses?: string; title?: string; icon: string }> = ({
  title,
  cssClasses,
  icon,
}) => {
  return (
    <button className="dashboard-nav-tool dashboard-nav-tool-btn" type="button" onClick={() => {}}>
      <span className={`tb-icon tb-icon-2x tb-icon-stack tb-icon-clipboard ${cssClasses || ''}`} title={title}>
        <span className="tb-icon tb-icon-stack-2x">
          <Svg path="icon-clipboard" />
        </span>
        <span className="tb-icon tb-icon-stack-1x">
          <Svg path={`icon-${icon}`} />
        </span>
      </span>
    </button>
  );
};

export const NewsStatusIcon: FC = () => {
  const feedInfo = useStateSelector(s => {
    const { status, message, isReconnecting } = s.newsFeedProvider;
    const isClosed = status === 'closed';
    const isConnected = status === 'open';
    const isError = status === 'error' ? true : isClosed && isReconnecting === false ? true : false;

    return { status, message, isConnected, isError, isWarning: isClosed, isPending: status === undefined };
  });

  const cssClasses = feedInfo.isError ? 'neg' : feedInfo.isWarning ? 'warn' : feedInfo.isPending ? 'pending' : '';
  const title = feedInfo.message
    ? feedInfo.message
    : feedInfo.isPending
    ? 'Connecting...'
    : `Cannot connect to ${GetTradingBlockSiteName()} API`;
  return (
    <>
      {(feedInfo.isError || feedInfo.isWarning || feedInfo.isPending) && (
        <NewsStatusIconButton icon="lightning" cssClasses={cssClasses} title={title} />
      )}
    </>
  );
};
